import { render } from "./Projections.vue?vue&type=template&id=5b1053cd"
import script from "./Projections.vue?vue&type=script&lang=js"
export * from "./Projections.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__